import React from 'react';
import SearchBar from './search/Search';
import SelectedFavourites from './selectedOverview/SelectedFavourites';
const FavouriteSelcetion: React.FC = () => {
  return (
    <>
      <SearchBar />
      <SelectedFavourites />
    </>
  );
};

export default FavouriteSelcetion;
